import {Model} from './model';

export enum AiReportSummaryStatus {
  NOT_STARTED = 'not started',
  GENERATING = 'generating',
  COMPLETED = 'completed'
}

export interface AiReportSummaryStatusResponse {
  status: AiReportSummaryStatus;
  remaining_seconds: number;
}

export class AiReportSummary implements Model {
  id: number;
  project_id: number;
  text_output: string;
  status: 'not started' | 'generating' | 'completed' | 'failed';
  remaining_seconds: number | null;
  type: string;
}
